import TemplateView from '../../../TemplateView'
import {connect} from '../../../redux/utils'
import {geSelectedYear, isLoading} from '../selectors'
import CalendarHeader from './CalendarHeader'
import Calendar from './Calendar'
import HolidayListPanel from './panels/holidayList/components/HolidayListPanel'
import {openPanel, setPanelSelectedYear} from './panels/holidayList/actions'
import {bindActionCreators} from 'redux'
import ImportHolidaysPanelContainer from './panels/importHolidays/components/ImportHolidaysPanelContainer'

class PageContent extends TemplateView {
    constructor({
        openHolidayListPanel,
        setSelectedYearHolidayPanel
    }) {
        super()

        this.actions = {
            openHolidayListPanel,
            setSelectedYearHolidayPanel
        }

        this.state = {
            loading: false,
            year: ''
        }
    }

    templateHtml() {
        return "<div class='content'>" +
               "    <div class='header'/>" +
               "    <div class='calendar'/>" +
               "    <div class='holidayPanels'/>" +
               "</div>"
    }

    afterRender() {
        this.$holidayPanels = this.find('.holidayPanels')
        this.holidayPanel = new HolidayListPanel().init(this.$holidayPanels)
        this.importHolidaysPanel = new ImportHolidaysPanelContainer().init(this.$holidayPanels)

        this.header = new CalendarHeader({
            onHolidayListButtonClick: () => {
                this.actions.setSelectedYearHolidayPanel(this.state.year)
                this.actions.openHolidayListPanel()
            }
        }).init(this.find('.header'))
        this.calendar = new Calendar().init(this.find('.calendar'))
    }
}

export default connect(
    (state) => ({
        loading: isLoading(state),
        year: geSelectedYear(state)
    }),
    (dispatch) => ({
        setSelectedYearHolidayPanel: bindActionCreators(setPanelSelectedYear, dispatch),
        openHolidayListPanel: bindActionCreators(openPanel, dispatch)
    })
)(PageContent)


// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/PageContent.js